import { connect } from "@formily/react";
import { FormButtonGroup as AntFormButtonGroup } from "@formily/antd-v5";

export const FormButtonGroup = connect((props) => {
  const enhancedProps = {
    ...props,
  };

  return <AntFormButtonGroup {...enhancedProps} />;
});
